import Image from 'next/image';
import type { TenantImageProps } from './TenantImage.types';

/**
 * Image for the tenant marketing sites — `next/image` over a file stored in this repo.
 *
 * ## Invariants:
 * - Lazy-loads unless `priority` is set. Why: the marketing pages carry dozens of large photos
 *   below the fold; only the hero is worth fetching up front.
 * - Callers pass either `fill` (inside a sized, positioned box) or the intrinsic `width`/`height`
 *   from the site's `*_IMAGE_SIZES` manifest, plus `sizes`, so the browser picks a right-sized
 *   variant and the layout does not shift while images load.
 */
export function TenantImage({ alt, priority = false, ...props }: TenantImageProps) {
  return (
    <Image
      {...props}
      alt={alt}
      preload={priority}
      loading={priority ? 'eager' : 'lazy'}
      fetchPriority={priority ? 'high' : undefined}
    />
  );
}
